export default __webpack_public_path__ + "static/media/rebrain-neuro-modulation-surgery-targeting-treatment-deep-brain-stimulation-bg26.589ea63e.webp";